type CableSystemMessage = {
  type?: "ping" | "welcome" | "confirm_subscription" | "disconnect" | "reject_subscription";
};

type CableEnvelope<T> = CableSystemMessage & {
  message?: T;
};

type CableSubscription<T> = {
  channel: string;
  params?: Record<string, string | number>;
  onMessage: (message: T) => void;
};

function isCableEnvelope<T>(value: unknown): value is CableEnvelope<T> {
  return typeof value === "object" && value !== null;
}

export function subscribeToCable<T>({ channel, params = {}, onMessage }: CableSubscription<T>) {
  const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
  const ws = new WebSocket(`${protocol}//${window.location.host}/cable`);

  ws.onopen = () => {
    ws.send(JSON.stringify({
      command: "subscribe",
      identifier: JSON.stringify({ channel, ...params }),
    }));
  };

  ws.onmessage = (event) => {
    const parsed: unknown = JSON.parse(event.data);
    if (!isCableEnvelope<T>(parsed)) return;
    if (parsed.type === "ping" || parsed.type === "welcome" || parsed.type === "confirm_subscription") return;
    if (parsed.message === undefined) return;

    onMessage(parsed.message);
  };

  return () => ws.close();
}
